import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import React from 'react';
import { string, oneOf, func } from 'prop-types';
import { Icon } from '@magalu/stereo-ui-icons';
import Flex from '../Flex';
import Text from '../Text';
const byType = {
  like: {
    icon: 'Like'
  },
  dislike: {
    icon: 'Dislike'
  }
};

function ConfirmButton(_ref) {
  let {
    type,
    label,
    onClick,
    color
  } = _ref,
      props = _objectWithoutPropertiesLoose(_ref, ["type", "label", "onClick", "color"]);

  const {
    icon
  } = byType[type];
  return /*#__PURE__*/React.createElement(Flex, _extends({
    alignItems: "center",
    onClick: onClick
  }, props), /*#__PURE__*/React.createElement(Icon, {
    name: icon,
    color: color,
    cursor: "pointer"
  }), /*#__PURE__*/React.createElement(Text, {
    ml: "6px"
  }, label));
}

process.env.NODE_ENV !== "production" ? ConfirmButton.propTypes = {
  color: string,
  type: oneOf(['like', 'dislike']),
  label: string,
  onClick: func
} : void 0;
export default ConfirmButton;